import React from 'react';
import { connect } from 'react-redux';
import Button from '../../../../CommonComponents/BootstrapComponents/Button/Button';
import './ReturnAddress.scss';
import StoreAddress from '../../../../mobile/components/ReturnExchange/StoreAddress';

function ReturnAddress(props) {
  const {
    dataLocale,
    addressType,
    desktopFlow,
    desktopFlowSuccess,
    dataLocale: {
      CHANGE,
      ADDRESS_TO_PROCEED,
      SELECT_ADDRESS,
      SHIP_PRODUCT,
      STORE_ADDRESS,
      YOUR_ADDRESS,
      PICKUP_ADDRESS,
    },
    changeAddress,
    returnMethodConfig,
    returnMethod,
    fadeLabel,
    disableChange,
    userAddress,
    storeAddress,
    callStore = '',
    shipLabel,
    pickupLabel,
    changeStoreAddress,
    triggerDtmOnClick,
    noMarginBottom,
  } = props;
  let completeAddress = '';
  if (userAddress && Object.keys(userAddress).length > 0) {
    const { addressline1, addressline2, city, state, postcode } = userAddress;
    if (addressline1) completeAddress += addressline1;
    if (addressline2) completeAddress += `${completeAddress ? ', ' : ''}${addressline2}`;
    if (city) completeAddress += `${completeAddress ? ', ' : ''}${city}`;
    if (state) completeAddress += `${completeAddress ? ', ' : ''}${state}`;
    if (postcode) completeAddress += `${completeAddress ? ', ' : ''}${postcode}`;
  }
  return (
    <div
      className={`pd-10 bg-color_white ${noMarginBottom ? '' : 'mr-b10'}`}
      data-testid="returnAddress"
    >
      {(!returnMethod || returnMethod === 'schedule_pickup') &&
        (completeAddress ? (
          <React.Fragment>
            <div className="display-flex justify-space-between">
              {pickupLabel ? (
                <div className="color-lightgrey fs12 text-uppercase fw400">
                  {addressType || PICKUP_ADDRESS}
                </div>
              ) : (
                ''
              )}
              {!disableChange && (
                <div
                  className="fs14 fw500 text-uppercase"
                  style={{ color: '#00b9c6' }}
                  onClick={changeAddress}
                >
                  {CHANGE}
                </div>
              )}
            </div>
            <div className="lh-16 fs14 fw500 text-color_grey_black">
              {pickupLabel || YOUR_ADDRESS}
            </div>
            <div
              className="mr-t8 fs13 lh-19 color-lightgrey"
              style={{ flexBasis: disableChange ? '100%' : '80%' }}
            >
              {completeAddress}
            </div>
          </React.Fragment>
        ) : (
          <div className="display-flex justify-space-between align-items-center">
            <div className="fs13 lh-19 text-color_dull_black" style={{ flexBasis: '60%' }}>
              {ADDRESS_TO_PROCEED}
            </div>
            {!disableChange && (
              <Button className="theme-button" onClick={changeAddress}>
                {SELECT_ADDRESS}
              </Button>
            )}
            {/* {!disableChange && (
              <div className="new-btn return-btn fw500 bg-topaz" onClick={changeAddress}>
                <span className="block lh-14 text-color_white text-uppercase">
                  {SELECT_ADDRESS}
                </span>
              </div>
            )} */}
          </div>
        ))}
      {returnMethod === 'warehouse_return' && (
        <React.Fragment>
          <div
            className={`lh-16 ${
              fadeLabel ? 'fs12 text-color_pale_black' : 'fs14 fw500 text-color_grey_black'
            }`}
          >
            {shipLabel || SHIP_PRODUCT}
          </div>
          <div className="mr-t5">
            <div className={`text-color_dull_black${fadeLabel ? ' fs14 lh-19' : ''}`}>
              {returnMethodConfig.warehouseAddress}
            </div>
          </div>
        </React.Fragment>
      )}
      {returnMethod === 'store_return' && storeAddress && (
        <StoreAddress
          fadeLabel
          callStore={callStore}
          changeStoreAddress={changeStoreAddress}
          dataLocale={dataLocale}
          desktopFlow={desktopFlow}
          desktopFlowSuccess={desktopFlowSuccess}
          headerLabel={STORE_ADDRESS}
          storeDetails={storeAddress}
          triggerDtmOnClick={triggerDtmOnClick}
        />
      )}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    dataLocale: state.locale,
  };
}

export default connect(mapStateToProps, null)(ReturnAddress);
